<template>
  <div class="myanli">
    <myHeader />
    <div class="bg">
      <div>
        <h1 style="font-size:26px">案例展示</h1>
      </div>
      <div class="app">
        <div class="case_wrap">
          <div class="case_top">
            <div class="nav_level">
              <div class="switch_list" ref="switch_list">
                <span v-for="(item, index) in case_nav_list" :key="index" v-text="item.title"
                  @click="handleClickNav(item, index, item.type)" :class="{ active: currentTabIndex === index }"></span>
              </div>
              <div class="underline" :style="{
                width: underlineWidth + 'px',
                left: underlineLeft + 'px',
              }"></div>
            </div>
            <div class="nav_child " :class="{ expand_retract: expand_retract }" ref="nav_child_content"
              :style="{ height: boxHeight + 'px' }">
            </div>
          </div>
          <div class="case_bottom">
            <div class="case-list2">
              <!-- 修改部分 -->
              <div v-for="(caseItem, index) in cases" :key="index"
                class="case-item2" @click="pageTransition(caseItem)">
                <img :src="caseItem.cover" alt="案例图片" />
                <div class="case-info">
                  <h3>{{ caseItem.title }}</h3>
                  <p>{{ caseItem.subTitle }}</p>
                  <p>{{ caseItem.name }}</p>
                </div>
              </div>
            </div>
            <!-- 修改部分 -->
            <button v-if="!showAll" @click="showAllCases" class="butt">
              查看全部案例
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频详情组件 -->

    <my-footer />
   <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import MyFooter from "@/components/mobile/myFooter.vue";
import videoPlayback from "@/components/mobile/videoPlayback.vue";
import { getCaseClassificationList, getCaseList } from "@/api/api";

export default {
  components: { myHeader, MyFooter,videoPlayback },
  data() {
    return {
      showVideoPlayer: false,
      videoUrl:'',
      // baseUrl: 'https://www.hecoos.com/',
      list: [],
      VideoDetailsIsShow: false,
      videoDetailMsg: {},
      videoList: {},
      cases: [

      ],
      case_nav_list:[
        {
          title:'xR/VP',
          id:1,
          children:[
            {id:1,title:'舞台演出'},
            {id:2,title:'舞台演出1'},
            {id:3,title:'舞台演出2'},
            {id:4,title:'舞台演出3'},
            {id:4,title:'舞台演出3'},
          ]
        },
        {
          title:'展演案例',
          id:2,
          children: [
            {id:1,title:'舞台演出'},
            {id:2,title:'展览'},
            {id:3,title:'演唱会'},
            {id:4,title:'电影电视剧'},
            {id:5,title:'广播电视栏目'},
            {id:6,title:'TVC广告'},
            {id:7,title:'沉浸式展览'},
          ]
        },
      ],
      expand_retract:true,
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      currentChildIndex:0,
      boxHeight:0,
      showAll: false,
      pageNum:1,
      currentTabType:''
    };
  },
  computed: {
     filteredCases() {
      if (this.selectedCategory === "ALL_CASES") {
        return this.cases;
      }
      const selectedChild =
        this.case_nav_list[this.currentTabIndex].children[this.currentChildIndex];
      return this.cases.filter(
        (caseItem) => caseItem.category === selectedChild.title
      );
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener('resize', this.updateUnderlinePosition);
      // 初始时设置为展开高度
      this.$refs.nav_child_content.style.height = 'auto';
      this.boxHeight = this.$refs.nav_child_content.scrollHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  created() {
    this.getCaseClassificationLists()
  },
  methods: {
    // 点击一级菜单
    handleClickNav(item, index, type) {
      // console.log(123);
      this.currentTabType = type
      this.handleClickSearch()
      const currentTabIndex = this.currentTabIndex;
      this.expand_retract = !this.expand_retract;
      const navChildContent = this.$refs.nav_child_content;
      if (!navChildContent) {
        console.error("未找到 nav_child_content 引用");
        return;
      }
      const setHeightWithTransition = (height, duration = "0.5s") => {
        navChildContent.style.transition = `height ${duration} ease`;
        this.boxHeight = height;
        navChildContent.style.height = `${height}px`;
      };
      const getFullHeight = () => {
        navChildContent.style.height = "auto";
        const fullHeight = navChildContent.offsetHeight;
        navChildContent.style.height = "0px";
        return fullHeight;
      };
      if (currentTabIndex !== index) {
        setHeightWithTransition(0);
        const fullHeight = getFullHeight();
        setTimeout(() => {
          setHeightWithTransition(fullHeight);
          if (currentTabIndex !== index) {
            this.expand_retract = true;
          }
        }, 300);
      } else {
        if (this.expand_retract) {
          const fullHeight = getFullHeight();
          setTimeout(() => {
            setHeightWithTransition(fullHeight, "0.3s");
          }, 0);
        } else {
          setHeightWithTransition(0, "0.3s");
        }
      }
      this.currentTabIndex = index;
      this.currentChildIndex = 0;
      this.updateUnderlinePosition();
    },

    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();
        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);
        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
    // 修改部分
    showAllCases() {
      this.pageNum = this.pageNum + 1
      this.getCaseList()
    },

    goViewDetails(videoUrl) {
      window.open(videoUrl);
    },

    // 获取案例分类列表
    getCaseClassificationLists() {
      getCaseClassificationList().then((res) => {
        this.case_nav_list.forEach((item, index) => {
          item.title = res.data[index].title
          item.type = res.data[index].id
        });
        this.currentTabType =  this.case_nav_list ?  this.case_nav_list[0].type : ''

        this.handleClickSearch()
      })
    },
    handleClickSearch(){
      this.pageNum = 1
      this.cases = []
      this.showAll = false
      this.getCaseList()
    },
    getCaseList(){
      let postData = {
        page: this.pageNum,
        limit:9,
        type: this.currentTabType,
      };
      getCaseList(postData).then((res) => {
        let {data} = res
        if(data.length < 9){
          this.showAll = true
        }
        this.cases =  this.cases.concat(data);
      });
    },



    pageTransition(item) {
      if (item && item.link) {
        this.showVideoPlayer = true;
        this.videoUrl = item.link;
        document.body.style.overflow = 'hidden'; // 禁止页面滚动

      } else {
        console.error("item is undefined or does not have a link property");
      }
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
    closeDetail() {
      // 将视频详情组件的显示状态设置为隐藏
      this.VideoDetailsIsShow = false;
      // 恢复页面的正常滑动
      document.body.style.overflow = 'auto';
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/mobile_wsc.scss";
.case-item2{
  position: relative;
}
</style>
